"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Text = _interopRequireDefault(require("../../Text"));
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const NotificationRow = ({
  title,
  description,
  icon,
  hideBorderBottom,
  extraInfo,
  onClick
}) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.StyledButton, {
  nostyle: true,
  onClick: onClick,
  trackingName: "Felles",
  trackingEvent: "Klikk varselelement",
  "aria-label": `Varsel om {title}`,
  children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Wrapper, {
    hideBorderBottom: hideBorderBottom,
    children: [icon, /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.TextContent, {
      children: [extraInfo && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
        subtle: true,
        small: true,
        children: extraInfo
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Text.default, {
        small: true,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
          small: true,
          semibold: true,
          children: title
        }), ' ' + description]
      })]
    })]
  })
});
var _default = exports.default = NotificationRow;